






































































import Vue from "vue";

// Interfaces
import {
  secondsToTime,
  unixTimeToReadableDate,
} from "@/interfaces/time.interface";
import { Workout } from "@/interfaces/workout.interface";
import { getExerciseType, Exercise } from "@/interfaces/exercise.interface";

export default Vue.extend({
  props: {
    doneWorkingOutDialog: {
      type: Boolean,
      default: false,
    },
    workoutData: Object as () => Workout,
  },
  methods: {
    dialogController() {
      this.$emit("dialogController", "closeAll");
    },
    secondsToTime(totalSeconds: number): string {
      return secondsToTime(totalSeconds, true);
    },
    unixTimeToReadableDate(timeStamp: number): string {
      return unixTimeToReadableDate(timeStamp);
    },
    getExerciseType(
      exercise: Exercise
    ): "Cardio" | "Reps" | "Duration" | "Weights" | undefined {
      return getExerciseType(exercise);
    },
  },
});
